module.exports = __webpack_public_path__ + "static/morgan-bc9832118fddcfd2df00b16ce6014c4b.jpg";